import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { BsArrowRight } from "react-icons/bs"

const ClientStart = ({ text }) => (
  <div className="section border-bottom-0 client-start-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="lets-talk-wrapper">
            <h3>{text}</h3>
            <Link to="/contact-us" class="btn">
              Let's Talk
              <span>
                {" "}
                <BsArrowRight />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
)

ClientStart.defaultProps = {
  text: `Ready to start your project?`,
}

ClientStart.propTypes = {
  text: PropTypes.string,
}

export default ClientStart
